import { Header as HeaderWidget } from "@/components/header/index";
import { SectionPage } from "@/components/section-page";
import { LocalizationText } from "@/app/index";
import { useHeaderStyles } from "./header.styles";
import { useMemo } from "react";

import { usePageContextInvoiceView } from "../../context/invoice-view-context";

import HeaderLogoSvg from "../../static/header-logo.svg?react";

export const ModuleHeader = () => {
  const { styles } = useHeaderStyles();
  const { invoice, currentLang } = usePageContextInvoiceView();

  const breadcrumbItems = useMemo(
    () => [
      {
        title: <LocalizationText value="invoice.view.header.breadcrumb.home" />,
        href: `/${currentLang}/home`,
      },
      {
        title: (
          <LocalizationText value="invoice.view.header.breadcrumb.invoices" />
        ),
        href: `/${currentLang}/billing/invoices`,
      },
      {
        title: invoice?.Number,
      },
    ],
    [currentLang, invoice?.Number],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <HeaderWidget
        icon={<HeaderLogoSvg />}
        title={
          <LocalizationText
            value="invoice.view.header.title"
            templateData={{
              invoiceNumber: invoice?.Number,
            }}
          />
        }
        breadcrumbItems={breadcrumbItems}
      />
    </SectionPage>
  );
};
